import { filterByPrepayment } from '@features/firstPaymentDefinition/filterByPrepayments';

export default (product, prepayments) => {
    const allFirstPaymentDefinitions = product.get('allFirstPaymentDefinitions');
    return filterByPrepayment(allFirstPaymentDefinitions, prepayments || []);
};
